import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/rem'
import './assets/css/base/style.less'
import './assets/css/base/common.css'
import './utils/vant'   // 按需引入vant组件库
import 'vant/lib/icon/local.css';
import './utils/fun'
import service from './utils/request'
import GLOBAL from './utils/global'
import Api from "./api/index"
import VDistpicker from 'v-distpicker'
Vue.component('v-distpicker',VDistpicker)
import NoData from '@/components/common/noData/noData'
Vue.component("NoData", NoData)

import Gohome from '@/components/gohome/gohome';
Vue.component("Gohome", Gohome)


Vue.prototype.GLOBAL = GLOBAL
Vue.prototype.ApiNew = Api
//配置图片懒加载
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
// Vue.use(service)
Vue.prototype.Api = service
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
Vue.use(VueVideoPlayer)


Vue.prototype.goLogin = () => {  // 全局方法  弹出登录框
  store.commit("Login/editLoginDialog", true)
}
Vue.prototype.customerClick = () => {
  window.location.href = "https://url.cn/xhAlQ0vv?_type=wpa&qidian=true";
}
Vue.prototype.getTokenType = () => {
  let token = localStorage.getItem("setToken")
  if (token != null && token != "" && token != undefined) {
    return true
  }
  return false
}
Vue.config.productionTip = false
// 设置标题
Vue.use(require('vue-wechat-title'));
// 全局挂载bus
const bus = new Vue();
Vue.prototype.bus = bus;


//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import toast from "@/components/toast/tosatInfo.vue"
// import { from } from 'core-js/core/array'
Vue.component('toast', toast);

router.beforeEach((to, from, next) => {
  var u = navigator.userAgent;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  // <!-- 百度统计  -->
  var _hmt = _hmt || [];
  (function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?794ee6d95737001d15a364745b62b65a";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
  if (isiOS && to.path !== location.pathname) {
    location.assign(to.fullPath)
  }else {
    next();
  }
})
Vue.prototype.onClickLeft = function () {   // 全局绑定方法  后退一步
  window.location.href = "javascript:history.go(-1)"

}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
